import { brandInfo, footerColumns } from "@/mocks/home";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md flex items-center justify-center bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                {brandInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm text-background-100/70 leading-relaxed max-w-sm">
              {brandInfo.slogan}。我们整理投稿规则、审核时效与隐私保护说明，帮助每一位投稿人把线索交到对的地方。
            </p>
            <a
              href={`mailto:${brandInfo.email}`}
              className="mt-5 inline-flex items-center gap-2 text-sm text-background-100 hover:text-background-50"
            >
              <i className="ri-mail-line"></i>
              {brandInfo.email}
            </a>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="lg:col-span-2">
              <h4 className="font-heading font-bold text-sm text-background-50">
                {column.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/70 hover:text-background-50 whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-3">
            <h4 className="font-heading font-bold text-sm text-background-50">投稿提示</h4>
            <p className="mt-4 text-sm text-background-100/70 leading-relaxed">
              请只提交你亲眼所见或能提供材料佐证的事实。我们不收取任何费用，也不会以任何名义要求转账。
            </p>
            <a
              href="#submit"
              className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors"
            >
              <i className="ri-send-plane-fill"></i>
              我要投稿
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs text-background-100/60">
            © {year} {brandInfo.name} · 爆料投稿指南
          </p>
          <nav aria-label="页脚导航" className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-100/60">
            <a href="#top" className="hover:text-background-50 whitespace-nowrap">返回顶部</a>
            <a href="#privacy" className="hover:text-background-50 whitespace-nowrap">隐私保护</a>
            <a href="#fee" className="hover:text-background-50 whitespace-nowrap">稿费规则</a>
            <a href="#faq" className="hover:text-background-50 whitespace-nowrap">常见问题</a>
          </nav>
        </div>
      </div>
    </footer>
  );
}